/**
 * ****************************************************************************
 * @description     :   Route for cm module
 * @created at      :   2023/07/11
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import component of view
 */
const cm0011i = () => import('@/views/cm/cm0011i');
const cm0020i = () => import('@/views/cm/cm0020i');
const cm0050i = () => import('@/views/cm/cm0050i');
const cm0021i = () => import('@/views/cm/cm0021i');
const cm0070i = () => import('@/views/cm/cm0070i');
const cm0100i = () => import('@/views/cm/cm0100i');
const cm0110i = () => import('@/views/cm/cm0110i');
const cm0061i = () => import('@/views/cm/cm0061i');
const cm9020i = () => import('@/views/cm/cm9020i');
const authentication = () => import('@/views/cm/cm0011i/authentication');
const authenticationBackupcode = () =>
    import('@/views/cm/cm0011i/authentication/authenticationBackupcode');
const settingAuthentication = () =>
    import('@/views/cm/cm0011i/settingAuthentication');
/**
 * Defined Router
 */
const resource = 'cm';
export default [
    {
        path: '/private/login',
        name: 'Cm0011i',
        component: cm0011i,
        meta: {
            title: 'ログイン',
            layout: 'EmptyLayout',
            spScreen: '/gm/gm0010i',
            notCheckPublic: true
        }
    },
    {
        path: '/public/login',
        name: 'Cm0011iPublic',
        component: cm0011i,
        meta: {
            title: 'ログイン',
            layout: 'EmptyLayout',
            notCheckPublic: true
        }
    },
    {
        path: `/${resource}/cm0020i`,
        name: 'Cm0020i',
        component: cm0020i,
        meta: {
            title: '法人設定'
        }
    },
    {
        path: `/${resource}/cm0050i`,
        name: 'Cm0050i',
        component: cm0050i,
        meta: {
            title: '事業所情報の設定'
        }
    },
    {
        path: `/${resource}/cm0021i`,
        name: 'Cm0021i',
        component: cm0021i,
        meta: {
            title: 'システム設定'
        }
    },
    {
        path: `/${resource}/cm0070i`,
        name: 'Cm0070i',
        component: cm0070i,
        meta: {
            title: '職種情報の設定'
        }
    },
    {
        path: `/${resource}/cm0100i`,
        name: 'Cm0100i',
        component: cm0100i,
        meta: {
            title: '従業員情報の設定'
        }
    },
    {
        path: `/${resource}/cm0110i`,
        name: 'Cm0110i',
        component: cm0110i,
        meta: {
            title: '役職情報の設定'
        }
    },
    {
        path: `/${resource}/cm0061i`,
        name: 'Cm0061i',
        component: cm0061i,
        meta: {
            title: '組織情報の設定'
        }
    },
    {
        path: `/${resource}/cm9020i`,
        name: 'Cm9020i',
        component: cm9020i,
        meta: {
            title: 'マスタ送受信'
        }
    },
    {
        path: `/authentication`,
        name: 'authentication',
        component: authentication,
        meta: {
            title: '2要素認証',
            layout: 'EmptyLayout',
            spScreen: '/gm/authentication_mobile',
            notCheckPublic: true
        }
    },
    {
        path: `/authentication/authenticationBackupcode`,
        name: 'authenticationBackupcode',
        component: authenticationBackupcode,
        meta: {
            title: '2要素認証(バックアップコード使用)',
            layout: 'EmptyLayout',
            spScreen: '/gm/backupcode_mobile',
            notCheckPublic: true
        }
    },
    {
        path: `/settingAuthentication`,
        name: 'settingAuthentication',
        component: settingAuthentication,
        meta: {
            title: '2要素認証の設定',
            layout: 'EmptyLayout',
            notCheckPublic: true
        }
    }
];
